import { useMemo } from 'react';

import { emptyArray } from 'ui-components/default-props/empty';
import { PrepaidDuty } from '../duties-and-taxes/constants';

const usePrepaidDutyAndPrice = ({ availableShippingOptions, options }) => {
  const { prepaidDuty, price } = useMemo(() => {
    const availablePrepaidDutyShippingOptions = (availableShippingOptions || emptyArray).filter(
      ({ additionalOptionEnum }) => additionalOptionEnum === PrepaidDuty,
    );

    const selectedPrepaidDutyShippingOption = (options?.additionalOptions || emptyArray).find(
      ({ additionalOptionEnum }) => additionalOptionEnum === PrepaidDuty,
    );

    const selectedPrepaidDutyShippingOptionType = selectedPrepaidDutyShippingOption?.additionalOptionValue?.prepaidDuty;

    const prepaidDutyShippingOption = availablePrepaidDutyShippingOptions.find(
      ({ additionalOptionValue }) => additionalOptionValue?.prepaidDuty === selectedPrepaidDutyShippingOptionType,
    );

    return prepaidDutyShippingOption?.additionalOptionValue || {};
  }, [availableShippingOptions, options]);

  return { prepaidDuty, price };
};

export { usePrepaidDutyAndPrice };
